export const DISPLAY_MODE_REVJET = 'revjet';
export const DISPLAY_MODE_ETCH = 'display rich content';
export const SALSIFY = 'Salsify';
